exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-680aaf19] {\n  opacity: 0.2;\n}\n.actions[data-v-680aaf19] {\n  z-index: 3;\n  width: 280px;\n  top: 1rem;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n  border: solid 1px #8f8f8f;\n  opacity: 1;\n}\n.actions > a[data-v-680aaf19] {\n  opacity: 1;\n}\n.cell[data-v-680aaf19] {\n  font-size: 0.8rem;\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.goal[data-v-680aaf19] {\n  border-bottom: solid 1px #8f8f8f;\n  background-color: #fff;\n}\n.goal.flagged[data-v-680aaf19] {\n  background-color: #fcf8ed;\n}", ""]);

// exports
